import columns from '../../../../../react-table/helpers/columns';
import ReportDefinitions from '../../../../../common/config/ReportDefinitions';
import { sumOfGroupTotals, totalRowPercentageWithGrandTotals } from '../../../../../react-table/helpers/rowTotals';
import CarrierM39ComplianceLocationReportMode from "./CarrierM39ComplianceLocationReportMode";

export const getDetailsTabNavigationProps = carrierData => (rowInfo, index) => (
  rowInfo && rowInfo.row ? {
    reportId: ReportDefinitions.CARDIT_CRITICAL_ELEMENTS_800_DETAILS.id,
    mainReportId: ReportDefinitions.CARDIT_CRITICAL_ELEMENTS_800_LOCATION.id,
    requestParams: {
      operator: rowInfo.row['postalOperator'], // eslint-disable-line
      originAirportCode: rowInfo.row['originAirport'][index], // eslint-disable-line
      destinationAirportCode: rowInfo.row.destinationAirport[index],
      carriers: carrierData.carriers,
      isSubtotal: index === 0,
    },
    selectionCriteriaOptions: {
      includeSelectionCriteria: true,
    },
  } : {}
);

export default (data, carrierData, mode = CarrierM39ComplianceLocationReportMode.percentage) => {
  const {
    MultilineNumberGroupedColumn,
    MultilineColumn,
    MultilineNumberNavigationWithFooterColumn,
    MultilinePercentageGroupedColumn,
    NonZeroNumberColumn,
  } = columns(data);
  return [
    {
      Header: '',
      columns: [
        new MultilineColumn('Postal operator', 'postalOperator')
          .withTotalHeader('', 'bg-total-grey'),
        new MultilineColumn('Origin', 'originAirport')
          .withTotalHeader('', 'bg-total-grey'),
        new MultilineColumn('Destination', 'destinationAirport')
          .withTotalHeader('', 'bg-total-grey'),
      ],
    },
    {
      Header: 'Consignments',
      columns: [
        new MultilineNumberGroupedColumn('Total', 'consignments.total')
          .withTotalHeader(sumOfGroupTotals, 'bg-total-grey'),

        new MultilineNumberGroupedColumn('LHOT origin', 'consignments.lhotOrigin', true, 'consignments.pctLhotOrigin')
          .withTotalHeader(sumOfGroupTotals, 'bg-total-grey')
          .withShow(mode === CarrierM39ComplianceLocationReportMode.number),
        new MultilineNumberGroupedColumn('LHOT destination', 'consignments.lhotDestination', true, 'consignments.pctLhotDestination')
          .withTotalHeader(sumOfGroupTotals, 'bg-total-grey')
          .withShow(mode === CarrierM39ComplianceLocationReportMode.number),
        new MultilineNumberGroupedColumn('Contract reference', 'consignments.contractReference', true, 'consignments.pctContractReference')
          .withTotalHeader(sumOfGroupTotals, 'bg-total-grey')
          .withShow(mode === CarrierM39ComplianceLocationReportMode.number),
        new MultilineNumberGroupedColumn('Booking reference (PAWB)', 'consignments.bookingReference', true, 'consignments.pctBookingReference')
          .withTotalHeader(sumOfGroupTotals, 'bg-total-grey')
          .withShow(mode === CarrierM39ComplianceLocationReportMode.number),

        new MultilinePercentageGroupedColumn('% LHOT origin', 'consignments.pctLhotOrigin', true, 'consignments.lhotOrigin')
          .withTotalHeader(totalRowPercentageWithGrandTotals(['consignments.lhotOrigin', 'consignments.total']), 'bg-total-grey')
          .withShow(mode === CarrierM39ComplianceLocationReportMode.percentage),
        new MultilinePercentageGroupedColumn('% LHOT destination', 'consignments.pctLhotDestination', true, 'consignments.lhotDestination')
          .withTotalHeader(totalRowPercentageWithGrandTotals(['consignments.lhotDestination', 'consignments.total']), 'bg-total-grey')
          .withShow(mode === CarrierM39ComplianceLocationReportMode.percentage),
        new MultilinePercentageGroupedColumn('% Contract reference', 'consignments.pctContractReference', true, 'consignments.contractReference')
          .withTotalHeader(totalRowPercentageWithGrandTotals(['consignments.contractReference', 'consignments.total']), 'bg-total-grey')
          .withShow(mode === CarrierM39ComplianceLocationReportMode.percentage),
        new MultilinePercentageGroupedColumn('% Booking reference (PAWB)', 'consignments.pctBookingReference', true, 'consignments.bookingReference')
          .withTotalHeader(totalRowPercentageWithGrandTotals(['consignments.bookingReference', 'consignments.total']), 'bg-total-grey')
          .withShow(mode === CarrierM39ComplianceLocationReportMode.percentage),
      ],
    },
    {
      Header: 'Receptacles',
      columns: [
        new MultilineNumberNavigationWithFooterColumn(
          new NonZeroNumberColumn('Total', 'receptacles.total')
            .withTotalHeader(sumOfGroupTotals, 'bg-total-grey'),
          getDetailsTabNavigationProps(carrierData),
        ),

        new MultilineNumberGroupedColumn('LHOT origin', 'receptacles.lhotOrigin', true, 'receptacles.pctLhotOrigin')
          .withTotalHeader(sumOfGroupTotals, 'bg-total-grey')
          .withShow(mode === CarrierM39ComplianceLocationReportMode.number),
        new MultilineNumberGroupedColumn('LHOT destination', 'receptacles.lhotDestination', true, 'receptacles.pctLhotDestination')
          .withTotalHeader(sumOfGroupTotals, 'bg-total-grey')
          .withShow(mode === CarrierM39ComplianceLocationReportMode.number),
        new MultilineNumberGroupedColumn('Contract reference', 'receptacles.contractReference', true, 'receptacles.pctContractReference')
          .withTotalHeader(sumOfGroupTotals, 'bg-total-grey')
          .withShow(mode === CarrierM39ComplianceLocationReportMode.number),
        new MultilineNumberGroupedColumn('Booking reference (PAWB)', 'receptacles.bookingReference', true, 'receptacles.pctBookingReference')
          .withTotalHeader(sumOfGroupTotals, 'bg-total-grey')
          .withShow(mode === CarrierM39ComplianceLocationReportMode.number),

        new MultilinePercentageGroupedColumn('% LHOT origin', 'receptacles.pctLhotOrigin', true, 'receptacles.lhotOrigin')
          .withTotalHeader(totalRowPercentageWithGrandTotals(['receptacles.lhotOrigin', 'receptacles.total']), 'bg-total-grey')
          .withShow(mode === CarrierM39ComplianceLocationReportMode.percentage),
        new MultilinePercentageGroupedColumn('% LHOT destination', 'receptacles.pctLhotDestination', true, 'receptacles.lhotDestination')
          .withTotalHeader(totalRowPercentageWithGrandTotals(['receptacles.lhotDestination', 'receptacles.total']), 'bg-total-grey')
          .withShow(mode === CarrierM39ComplianceLocationReportMode.percentage),
        new MultilinePercentageGroupedColumn('% Contract reference', 'receptacles.pctContractReference', true, 'receptacles.contractReference')
          .withTotalHeader(totalRowPercentageWithGrandTotals(['receptacles.contractReference', 'receptacles.total']), 'bg-total-grey')
          .withShow(mode === CarrierM39ComplianceLocationReportMode.percentage),
        new MultilinePercentageGroupedColumn('% Booking reference (PAWB)', 'receptacles.pctBookingReference', true, 'receptacles.bookingReference')
          .withTotalHeader(totalRowPercentageWithGrandTotals(['receptacles.bookingReference', 'receptacles.total']), 'bg-total-grey')
          .withShow(mode === CarrierM39ComplianceLocationReportMode.percentage),
      ],
      drillDownLink: {
        reportId: ReportDefinitions.CARDIT_CRITICAL_ELEMENTS_800_DETAILS.id,
        mainReportId: ReportDefinitions.CARDIT_CRITICAL_ELEMENTS_800_LOCATION.id,
        requestParams: {
          isTotal: carrierData.operator === '*', // since report expected to have one only group - * is handled on cape-be by reverting it back to ''
          isSubtotal: carrierData.operator !== '*', // since report expected to have one only group - * is handled on cape-be by reverting it back to ''
          operator: carrierData.operator,
        },
        selectionCriteriaOptions: {
          includeSelectionCriteria: true,
        },
      },
    },
  ];
};
